import { useEffect, useState } from "react";
import { api } from "./api";

let cache = null;

export function useRace() {
  const [race, setRace] = useState(cache);
  useEffect(() => {
    api.get("/race").then((r) => { cache = r.data; setRace(r.data); }).catch(() => {});
  }, []);
  return race;
}
